// extracted by mini-css-extract-plugin
export default {"item":"RolePickerBaseRole__item___AR5kH","currentLabel":"RolePickerBaseRole__currentLabel___t9d_t"};